/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class ISONEDayAheadPrices extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "ISONEDayAheadPrices";
}

const servicePlugin = makeServicePlugin({
  Model: ISONEDayAheadPrices,
  service: feathersClient.service("data-services/isone/day-ahead-locational-marginal-prices"),
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
